import { CompozzIcon } from "./CompozzIcon";
import { Dashboard } from "./Dashboard";
import { ObjectInfos } from "./objects";
import { Role } from "./Users";


interface Workspace {
    _key: string;
    name: string;
    order: number;
    description: string | null;
    color: string | null;
    icon: CompozzIcon | null;
    shared: boolean | null;
    drive?: boolean;
    // Stable identifier of the workspace, owned by the server: unlike the key, it survives an export/import
    uid?: string;
}

type WorkspaceForExport = {
	Workspace: Workspace;
	Objects: ObjectInfos[];
	Dashboards: Dashboard[];
	Roles: Role[];
}

type WorkspaceForImport = {
	content: string;
}

// One Compozz file of an import of several workspaces at once
type WorkspaceFileForImport = {
	// Name of the file, only used by the server to tell which file cannot be read
	name: string;
	// Content of the file (base64)
	content: string;
}

// Workspaces which depend on each other cannot be imported one after the other: they are imported together
type WorkspacesForImport = {
	files: WorkspaceFileForImport[];
}

type LoadTemplateRequest = {
	templateId: string;
}

// New display order of the workspaces of the tenant
type WorkspacesOrder = {
	// Keys of the workspaces, in their new display order
	keys: string[];
}

// i18n code of the error returned when an imported workspace references elements of shared
// workspaces which cannot be found in the tenant: the details of the error list them
const WORKSPACE_IMPORT_UNRESOLVED_REFERENCES = "compozz.error.workspace_import_unresolved_references.1";

// An element of the imported workspace which uses an unresolved reference
type ReferenceUsage = {
	kind: "relation" | "field" | "view" | "dashboard" | "role";
	name: string;
	// Name of the imported workspace which holds the element, only given when several workspaces are imported together
	workspace?: string;
}

// An element of a shared workspace, referenced by an imported workspace, which cannot be found in the tenant.
// When the whole shared workspace is missing, a single reference of kind "workspace" stands for all its
// elements: key, uid and name are then the ones of the workspace.
type UnresolvedReference = {
	kind: "workspace" | "object" | "field" | "relation";
	key: string;
	uid?: string;
	name?: string;
	wsName?: string;
	reason: "NOT_FOUND" | "AMBIGUOUS";
	candidates?: string[];
	usages?: ReferenceUsage[];
}

export { WORKSPACE_IMPORT_UNRESOLVED_REFERENCES };
export type { Workspace, WorkspaceForExport, WorkspaceForImport, WorkspaceFileForImport, WorkspacesForImport, WorkspacesOrder, LoadTemplateRequest, UnresolvedReference, ReferenceUsage };